// @flow
import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {media} from '../../utils/breakpoints';

import './DropdownPanelOverlay.less';

import type {State as ReduxState} from '../../reducers/index';

type ReduxProps = {
    isVisible: boolean
};

type Props = ReduxProps;

export class DropdownPanelOverlay extends PureComponent<Props> {
    stopImmediatePropagation(event: SyntheticEvent<*>) {
        event.stopPropagation();
        if (
            event &&
            event.nativeEvent &&
            typeof event.nativeEvent.stopImmediatePropagation === 'function'
        ) {
            event.nativeEvent.stopImmediatePropagation();
        }
    }

    render() {
        const {isVisible} = this.props;
        return isVisible ? (
            <div
                className="DropdownPanelOverlay"
                onClick={this.stopImmediatePropagation}
                onTouchStart={this.stopImmediatePropagation}
            />
        ) : null;
    }
}

const mapStateToProps = ({
    overlay,
    viewport: {breakpoint}
}: ReduxState): ReduxProps => {
    return {
        isVisible:
            overlay.showOverlay && media(breakpoint, {minWidth: 'SM_MIN'})
    };
};
export default compose(connect(mapStateToProps))(DropdownPanelOverlay);
